module.exports = __webpack_public_path__ + "426b897ea800d5fcc5688b3ace49933b.png";